"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.changeAttributeDisplayFormHandler = void 0;
var tslib_1 = require("tslib");
// (C) 2022-2023 GoodData Corporation
var effects_1 = require("redux-saga/effects");
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var redux_batched_actions_1 = require("redux-batched-actions");
var flatMap_1 = tslib_1.__importDefault(require("lodash/flatMap"));
var filters_1 = require("../../../events/filters");
var filterContext_1 = require("../../../store/filterContext");
var filterContextSelectors_1 = require("../../../store/filterContext/filterContextSelectors");
var common_1 = require("../common");
var eventDispatcher_1 = require("../../../store/_infra/eventDispatcher");
var filterDisplayFormValidation_1 = require("./validation/filterDisplayFormValidation");
var general_1 = require("../../../events/general");
var catalogSelectors_1 = require("../../../store/catalog/catalogSelectors");
var queryCall_1 = require("../../../store/_infra/queryCall");
var queries_1 = require("../../../../model/queries");
var objRefMap_1 = require("../../../../_staging/metadata/objRefMap");
function changeAttributeDisplayFormHandler(ctx, cmd) {
    var _a, filterLocalId, displayForm, catalogDisplayFormsMap, attributes, attributeDisplayFormsMap, displayFormData, attribute, validationResult, message, changedFilter;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = cmd.payload, filterLocalId = _a.filterLocalId, displayForm = _a.displayForm;
                return [4 /*yield*/, effects_1.select(catalogSelectors_1.selectAllCatalogDisplayFormsMap)];
            case 1:
                catalogDisplayFormsMap = _b.sent();
                return [4 /*yield*/, effects_1.call(queryCall_1.query, queries_1.queryAttributeByDisplayForm([displayForm]))];
            case 2:
                attributes = _b.sent();
                attributeDisplayFormsMap = objRefMap_1.newDisplayFormMap(tslib_1.__spread(flatMap_1.default(attributes, function (a) { return a.displayForms; })));
                displayFormData = catalogDisplayFormsMap.get(displayForm) || attributeDisplayFormsMap.get(displayForm);
                ts_invariant_1.default(displayFormData, "Inconsistent state in changeAttributeDisplayFormHandler, cannot update attribute filter with display form not available in the catalog.");
                attribute = displayFormData === null || displayFormData === void 0 ? void 0 : displayFormData.attribute;
                return [4 /*yield*/, effects_1.call(filterDisplayFormValidation_1.validateFilterDisplayForm, ctx, attribute, displayForm)];
            case 3:
                validationResult = _b.sent();
                if (validationResult !== "VALID") {
                    message = validationResult === "INVALID_ATTRIBUTE_DISPLAY_FORM"
                        ? "The display form provided is not a valid display form of the attribute filter."
                        : "Cannot find the attribute for the display form used on the attribute filter.";
                    throw general_1.invalidArgumentsProvided(ctx, cmd, message);
                }
                return [4 /*yield*/, effects_1.put(redux_batched_actions_1.batchActions([
                        // keep the attribute display form field up to date
                        filterContext_1.filterContextActions.addAttributeFilterDisplayForm(displayFormData),
                        filterContext_1.filterContextActions.changeAttributeDisplayForm({
                            filterLocalId: filterLocalId,
                            displayForm: displayForm,
                        }),
                    ]))];
            case 4:
                _b.sent();
                return [4 /*yield*/, effects_1.select(filterContextSelectors_1.selectFilterContextAttributeFilterByLocalId(filterLocalId))];
            case 5:
                changedFilter = _b.sent();
                ts_invariant_1.default(changedFilter, "Inconsistent state in changeAttributeDisplayFormHandler, cannot update attribute filter for given local identifier.");
                return [4 /*yield*/, eventDispatcher_1.dispatchDashboardEvent(filters_1.attributeDisplayFormChanged(ctx, changedFilter, cmd.correlationId))];
            case 6:
                _b.sent();
                return [4 /*yield*/, effects_1.call(common_1.dispatchFilterContextChanged, ctx, cmd)];
            case 7:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
exports.changeAttributeDisplayFormHandler = changeAttributeDisplayFormHandler;
//# sourceMappingURL=changeAttributeDisplayFormHandler.js.map